














import { Vue, Component, Prop } from 'vue-property-decorator';
import Checkbox from '@/components/common/inputs/Checkbox.vue';

@Component({
  components: {
    Checkbox
  }
})
export default class Button extends Vue {
  @Prop(String) value!: string;
  @Prop(Boolean) disabled!: boolean;

  intervals = ['1', '2-5', '6-10', '10 +'];

  select(interval: string) {
    this.$emit('change', interval);
  }
}
